<div class="scaffold-create-button">
  <button
    pButton size="small"
    [rounded]="true"
    class="use-icon-button"
    (click)="createData(item.new_type,info,true,false)"
    *ngIf="item.button_type == 'circle'"
    [title]="item.translation_key_label||item.heading || 'create'| translation|translationFromString | transformText :item?.text_transform_label"
    [disabled]="checkDisable()">
    <span>
      <span *ngIf="item.use_icon"
            class="create-button-icon" style="font-size:2rem;">
        <i [ngClass]="item.icon"></i>
      </span>
      <span class="create-button-heading">{{item.translation_key_label||item.heading| translation|translationFromString | transformText :item?.text_transform_label}}</span>
    </span>
  </button>
  <p-button
    severity="info" variant="text"
    size="large"
    (click)="createData(item.new_type,info,true,false)"
    *ngIf="item.button_type == 'ghost'"

    [title]="item.translation_key_label||item.heading || 'create'| translation|translationFromString | transformText :item?.text_transform_label" [disabled]="checkDisable()">
    <span
      *ngIf="item.use_icon"
      class="create-button-icon">
      <i [ngClass]="item.icon"></i>
    </span>
    <span class="create-button-heading">{{item.translation_key_label||item.heading| translation|translationFromString | transformText :item?.text_transform_label}}</span>
  </p-button>
  <button
    pButton class="use-icon-button"
    severity="primary"
    (click)="createData(item.new_type,info,true,false)"
    *ngIf="item.button_type != 'circle' && item.button_type != 'ghost'"
    [title]="item.translation_key_label||item.heading || 'create'| translation|translationFromString | transformText :item?.text_transform_label" [disabled]="checkDisable()">
    <span
      *ngIf="item.use_icon"
      class="create-button-icon">
      <i [ngClass]="item.icon"></i>
    </span>
    <span class="create-button-heading">{{item.translation_key_label||item.heading| translation|translationFromString | transformText :item?.text_transform_label}}</span>
  </button>
</div>
